var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-app',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-progress-circular',{staticClass:"ma-auto",attrs:{"width":10,"color":"primary","size":125,"indeterminate":""}})],1)],1):_c('vue-extend-layouts')
}
var staticRenderFns = []

export { render, staticRenderFns }